import React, { useState } from "react";

const colors = [
    "#000000", "#ffffff", "#ef4444", "#22c55e", "#3b82f6",
    "#facc15", "#a855f7", "#ec4899", "#14b8a6", "#f97316"
];

export default function PixelDraw() {
    const gridSize = 10;
    const [pixels, setPixels] = useState(Array(gridSize * gridSize).fill("#1e293b"));
    const [selectedColor, setSelectedColor] = useState("#00ffa3");
    const [isDrawing, setIsDrawing] = useState(false);
    const [started, setStarted] = useState(false);

    const handlePixelClick = (index) => {
        const newPixels = [...pixels];
        newPixels[index] = selectedColor;
        setPixels(newPixels);
    };

    const handlePixelEnter = (index) => {
        if (isDrawing) {
            const newPixels = [...pixels];
            newPixels[index] = selectedColor;
            setPixels(newPixels);
        }
    };

    const clearCanvas = () => {
        setPixels(Array(gridSize * gridSize).fill("#1e293b"));
    };

    const fillAll = () => {
        setPixels(Array(gridSize * gridSize).fill(selectedColor));
    };

    if (!started) {
        return (
            <div style={{
                textAlign: "center",
                padding: "1rem",
                color: "#e5e7eb",
                background: "rgba(255,255,255,0.05)",
                borderRadius: "1rem",
                boxShadow: "0 0 25px rgba(0,255,200,0.15)"
            }}>
                <h4 style={{color:"#facc15", marginBottom:"0.5rem"}}>
                    <i className="fas fa-paint-brush" style={{marginRight:"6px"}}></i> Pixel Draw
                </h4>
                <p style={{fontSize:"0.85rem", marginBottom:"1rem"}}>
                    Crea la tua pixel art!
                </p>
                <button
                    onClick={() => setStarted(true)}
                    style={{
                        background:"linear-gradient(135deg,#facc15,#ca8a04)",
                        border:"none",
                        color:"#000",
                        fontWeight:"700",
                        padding:"0.6rem 1.2rem",
                        borderRadius:"0.5rem",
                        cursor:"pointer"
                    }}
                >
                    <i className="fas fa-play" style={{marginRight:"6px"}}></i> Inizia
                </button>
            </div>
        );
    }

    return (
        <div style={{
            textAlign: "center",
            padding: "1.5rem",
            color: "#e5e7eb",
            background: "rgba(255,255,255,0.05)",
            borderRadius: "1rem",
            boxShadow: "0 0 25px rgba(0,255,200,0.15)"
        }}>
            <h4 style={{color:"#facc15", marginBottom:"1rem"}}>
                <i className="fas fa-paint-brush" style={{marginRight:"6px"}}></i> Pixel Draw
            </h4>

            {/* Tavolozza colori */}
            <div style={{
                display:"flex",
                justifyContent:"center",
                gap:"0.4rem",
                marginBottom:"1rem",
                flexWrap:"wrap"
            }}>
                {colors.map((color, i) => (
                    <button
                        key={i}
                        onClick={() => setSelectedColor(color)}
                        style={{
                            width:"30px",
                            height:"30px",
                            borderRadius:"0.3rem",
                            background:color,
                            border: selectedColor === color
                                ? "3px solid #00ffa3"
                                : "2px solid rgba(255,255,255,0.2)",
                            cursor:"pointer",
                            transition:"all 0.2s ease"
                        }}
                    />
                ))}
            </div>

            {/* Canvas pixel */}
            <div
                style={{
                    display:"grid",
                    gridTemplateColumns:`repeat(${gridSize}, 1fr)`,
                    gap:"1px",
                    background:"rgba(0,0,0,0.3)",
                    padding:"2px",
                    borderRadius:"0.5rem",
                    marginBottom:"1rem",
                    maxWidth:"250px",
                    margin:"0 auto 1rem",
                    userSelect:"none"
                }}
                onMouseDown={() => setIsDrawing(true)}
                onMouseUp={() => setIsDrawing(false)}
                onMouseLeave={() => setIsDrawing(false)}
            >
                {pixels.map((color, i) => (
                    <div
                        key={i}
                        onClick={() => handlePixelClick(i)}
                        onMouseEnter={() => handlePixelEnter(i)}
                        style={{
                            aspectRatio:"1",
                            background:color,
                            cursor:"pointer",
                            transition:"all 0.1s ease"
                        }}
                    />
                ))}
            </div>

            {/* Controlli */}
            <div style={{display:"flex", gap:"0.5rem", flexWrap:"wrap"}}>
                <button
                    onClick={clearCanvas}
                    style={{
                        flex:1,
                        minWidth:"80px",
                        background:"rgba(239,68,68,0.2)",
                        border:"1px solid rgba(239,68,68,0.3)",
                        color:"#ef4444",
                        fontWeight:"700",
                        padding:"0.6rem 1rem",
                        borderRadius:"0.5rem",
                        cursor:"pointer",
                        fontSize:"0.8rem"
                    }}
                >
                    <i className="fas fa-eraser" style={{marginRight:"6px"}}></i> Pulisci
                </button>
                <button
                    onClick={fillAll}
                    style={{
                        flex:1,
                        minWidth:"80px",
                        background:"linear-gradient(135deg,#2563eb,#1e40af)",
                        border:"none",
                        color:"#fff",
                        fontWeight:"700",
                        padding:"0.6rem 1rem",
                        borderRadius:"0.5rem",
                        cursor:"pointer",
                        fontSize:"0.8rem"
                    }}
                >
                    <i className="fas fa-fill-drip" style={{marginRight:"6px"}}></i> Riempi
                </button>
            </div>

            <div style={{
                marginTop:"1rem",
                padding:"0.6rem",
                background:"rgba(59,130,246,0.1)",
                borderRadius:"0.5rem",
                fontSize:"0.75rem",
                color:"#94a3b8"
            }}>
                <i className="fas fa-info-circle" style={{marginRight:"6px"}}></i>
                Clicca o trascina per disegnare
            </div>
        </div>
    );
}